( function( global, $ ) {
    "use strict";

    var _events = {
        onTaxCategory: function() {
            var $taxInput = $(this),
                $formEntry = $taxInput.closest('[data-form-entry="tax"]'),
                $gstInput = $formEntry.find('[data-form-control="tax_gst"]'),
                $pstInput = $formEntry.find('[data-form-control="tax_pst"]'),
                taxValue = $taxInput.val(),
                stampTax = {};

            if (taxValue === '') {
                return;
            }

            if (this.selectize) {
                stampTax = this.selectize.options[taxValue]['stamp-tax'];
            } else {
                stampTax = $taxInput.find(':selected').data('data')['stamp-tax'];
            }

            if (stampTax) {
                $gstInput.attr('placeholder', stampTax.gst);
                $pstInput.attr('placeholder', stampTax.pst);
            }
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $formEntries = $container.find('form [data-form-entry="tax"]'),
            $taxInputs = $formEntries.find('[data-form-control="tax"]');

        $taxInputs.on('change', _events.onTaxCategory)
                  .trigger('change');
    });

}( window.groots, jQuery ));
